import styled from 'styled-components/macro';

export const ExpandedRowTd = styled.td`
  padding-left: 20px;
`;

export const ExpandedRowDiv = styled.div`
  padding: 20px 0 20px 0;
  border-top: 2px solid white;
`;
